import gql from 'graphql-tag'
import { RouteCoverageOrderField } from '../../../src/graphql/schema/types/route-coverage-order'
import { OrderFieldConfig } from '../../legacy-design-system/order'

export const orderFieldConfig: OrderFieldConfig<RouteCoverageOrderField> = {
  SIGNATURE: {
    direction: 'ASC',
    message: { id: 'title_route', defaultMessage: 'Route' }
  },
  DISCOVERED: {
    direction: 'DESC',
    message: { id: 'title_fistSeen_server' }
  },
  EXERCISED: {
    direction: 'DESC',
    message: {
      id: 'title_route_lastActivity',
      defaultMessage: 'Last Activity '
    }
  }
}

export const routeFragment = gql`
  fragment Route on Route {
    id
    hash
    signature
    discovered
    environments
    exercised
    servers {
      id
      name
      environment
      agentVersion
      enabled
    }
    serversTotal
    vulnerabilityCount
    criticalVulnerabilityCount
    status
    app {
      id
      name
    }
  }
`

export const maxServersShownByDefault = 3

const serverHeight = 19
const linkHeight = 20
const rowPadding = 39
const minimumRowHeight = 75

export function getRowHeightFromServerCount(visibleServerCount: number) {
  const rowHeightFromServerCount =
    rowPadding + linkHeight + visibleServerCount * serverHeight
  return rowHeightFromServerCount < minimumRowHeight
    ? minimumRowHeight
    : rowHeightFromServerCount
}
